module.exports = __webpack_public_path__ + "8ad18a9c722e9cf0f7d6f49c5670eadc.pdf";